import { api as $axios } from '@/helpers/interceptors'
import { STATIC_PAGE } from '@/constants/path'
import { meta } from '@/config/pagination'
import snakeCaseKeys from 'snakecase-keys'

const setUnLoading = (commit, status = false) => {
  commit('SET_STATE', {
    key: 'isLoading',
    value: status,
  })
}
const state = () => ({
  data: [],
  isLoading: false,
  meta,
})

// getters
const getters = {}

// actions
const actions = {
  async getTable({ commit }, params) {
    setUnLoading(commit, true)
    try {
      const res = await $axios(
        `${STATIC_PAGE}`,
        'get',
        snakeCaseKeys({ params }),
      )
      commit('SET_STATE', {
        key: 'data',
        value: res?.data?.data,
      })
      commit('SET_STATE', {
        key: 'meta',
        value: res?.data?.meta,
      })
      setUnLoading(commit)
    } catch (error) {
      commit('SET_STATE', { key: 'data', value: [] })
      commit('SET_STATE', {
        key: 'meta',
        value: meta,
      })
      setUnLoading(commit)
    }
  },

  async delete(_, id) {
    await $axios(`${STATIC_PAGE}/${id}`, 'delete')
  },

  async create({ commit }, payload) {
    try {
      commit('SET_LOADING', true)
      await $axios(STATIC_PAGE, 'post', snakeCaseKeys(payload))
      commit('SET_LOADING', false)
    } catch (e) {
      commit('SET_LOADING', false)
      return new Error(e)
    }
  },
  async edit({ commit }, payload) {
    try {
      commit('SET_LOADING', true)
      await $axios(
        `${STATIC_PAGE}/${payload.id}`,
        'put',
        snakeCaseKeys({
          position: payload.position,
          type: payload.type,
          slug: payload.slug,
          html: payload.html,
        }),
      )
      commit('SET_LOADING', false)
    } catch (e) {
      commit('SET_LOADING', false)
      return new Error(e)
    }
  },
  // eslint-disable-next-line no-empty-pattern
  async getById({}, id) {
    const { data } = await $axios(`${STATIC_PAGE}/${id}`, 'get')
    return data?.data
  },
  async update({ commit }, payload) {
    try {
      const id = payload.id
      delete payload.id

      commit('SET_LOADING', true)
      await $axios(
        `${STATIC_PAGE}/${id}`,
        'put',
        snakeCaseKeys(payload),
      )
      commit('SET_LOADING', false)
    } catch (e) {
      commit('SET_LOADING', false)
      return new Error(e)
    }
  },
}

// mutations
const mutations = {
  SET_STATE(state, ops) {
    state[ops.key] = ops.value
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
